import React from 'react';

import { cn } from '@src/lib/utils';

import { Highlight } from '@/components/ui/hero-highlight';

type TypographyType =
  | 'title'
  | 'titlesmall'
  | 'subtitle'
  | 'subtitleMetric'
  | 'header'
  | 'base'
  | 'small'
  | 'caption';
type TypographyAlignType = 'start' | 'center' | 'end' | 'justify';
interface TypographyProps {
  variant?: TypographyType;
  align?: TypographyAlignType;
  children: React.ReactNode | string;
  highlightedLines?: number[];
  className?: string;
  asHTML?: boolean;
}

export const getTypographyClassaname = (variant: TypographyType, align: TypographyAlignType) => {
  let classes = `cursor-default text-${align} `;
  if (variant === 'title') classes += 'text-gray-800 font-semibold text-4xl lg:text-7xl';
  else if (variant === 'titlesmall') classes += 'text-gray-800 font-semibold text-3xl lg:text-6xl';
  else if (variant === 'subtitle') classes += 'text-gray-800 font-semibold text-xl';
  else if (variant === 'subtitleMetric') classes += 'text-gray-800 font-semibold text-lg lg:text-xl';
  else if (variant === 'header') classes += 'text-gray-800 font-semibold text-2xl lg:text-3xl';
  else if (variant === 'base') classes += 'text-gray-800 font-base text-lg';
  else if (variant === 'small') classes += 'text-gray-800 font-base text-base';
  else if (variant === 'caption') classes += 'text-gray-800 text-sm';
  return classes;
};

export const Typography: React.FC<TypographyProps> = ({
  variant = 'base',
  align = 'start',
  highlightedLines = [],
  className = '',
  children,
  asHTML = false,
}: TypographyProps) => {
  const txt = typeof children === 'string' ? children.split('\n') : [];
  const parts = txt.length - 1;

  const atLeastOneHighlighted = highlightedLines.length > 0;

  const getBaseClassname = () => {
    return 'flex flex-col gap-1 relative';
  };

  const getClassName = () => {
    return `cursor-default flex flex-col items-center justify-center ${getBaseClassname()} ${getTypographyClassaname(variant, align)}`;
  };

  return (
    <div className={cn(getClassName(), className)}>
      {typeof children === 'string' &&
        txt.map((part, i) => (
          <React.Fragment key={`${part}-${i}`}>
            {highlightedLines.includes(i) ? (
              <Highlight className="w-fit px-12 text-black dark:text-white">{part}</Highlight>
            ) : !asHTML && !atLeastOneHighlighted ? (
              part
            ) : (
              <div
                className="w-full text-black dark:text-white"
                dangerouslySetInnerHTML={{ __html: part }}
              ></div>
            )}

            {i !== parts && !atLeastOneHighlighted && <br></br>}
          </React.Fragment>
        ))}
      {typeof children !== 'string' && children}
    </div>
  );
};
